import { Controller } from "@hotwired/stimulus"

// Przełącznik wariantu personalizacji sidebara na /toolkit/ui/sidebar: "Dla mnie" (user_setting)
// vs "Dla konta" (account, tylko admin). Przełączenie NAWIGUJE (reload z ?scope=), żeby oba
// warianty zawsze pokazywały aktualny stan z bazy — np. po edycji układu konta na żywo szary
// podgląd "Dla mnie" (dziedziczony) musi być świeży. connect() po starcie odtwarza wariant
// z ?scope=. Rejestrowany w controllers/index_account.js (ładowany na /account i /toolkit/ui).
//
// Wymagane data-attributes:
//   data-controller="sidebar-scope"
//   przyciski: data-sidebar-scope-target="btn" data-scope="user|account" data-action="sidebar-scope#switch"
//   panele:    data-sidebar-scope-target="panel" data-scope="user|account"
export default class extends Controller {
  static targets = ["panel", "btn"]

  // otwarcie na wariancie z ?scope= (po nawigacji/zapisie), jeśli pasuje
  connect() {
    const scope = new URLSearchParams(window.location.search).get("scope")
    if (scope && this.btnTargets.some(btn => btn.dataset.scope === scope)) {
      this.activate(scope)
    }
  }

  // reload z parametrem wariantu — świeży render z aktualnymi danymi z bazy
  switch(event) {
    const scope = event.currentTarget.dataset.scope
    window.location.href = `${window.location.pathname}?scope=${scope}`
  }

  activate(selected) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.scope !== selected)
    })

    this.btnTargets.forEach(btn => {
      const active = btn.dataset.scope === selected
      btn.classList.toggle("bg-blue-500", active)
      btn.classList.toggle("text-white", active)
      btn.classList.toggle("text-gray-500", !active)
      btn.classList.toggle("hover:text-gray-700", !active)
    })
  }
}
